import { render, staticRenderFns } from "./NicknameWidget.vue?vue&type=template&id=24138d22&scoped=true"
import script from "./NicknameWidget.vue?vue&type=script&lang=js"
export * from "./NicknameWidget.vue?vue&type=script&lang=js"
import style0 from "./NicknameWidget.vue?vue&type=style&index=0&id=24138d22&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24138d22",
  null
  
)

export default component.exports